module.exports = __webpack_public_path__ + "static/media/SimulatorImage-min.e2d71f87.jpg";